import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import _get from 'lodash/get'
import { FETCH_EVENT, UNSELECT_EVENT } from '../../../../_common/redux/events/actions'
import { FETCH_BRAND, UNSELECT_BRAND } from '../../../../_common/redux/brands/actions'
import { FETCH_EVENT_ADDONS, RESET_INITIAL_ADD_ON } from '../../../../_common/redux/addons/actions'
import {
  FETCH_EVENT_TICKETS,
  FETCH_EVENT_TABLES,
  RESET_INITIAL_TICKETS,
} from '../../../../_common/redux/tickets/actions'
import {
  get_event,
  get_event_tickets,
  get_event_addons,
  get_event_tables,
  get_brand,
} from '../../../../_common/core/selectors'
import EventDetails from './EventDetails'
import ConfirmModal from '../../../_library/ConfirmModal'
import { Steps } from '../../../_library/Steps'
import { get_tables_initial, get_tickets_initial } from '../../../../_common/core/selectors/tickets'
import { get_addons_initial } from '../../../../_common/core/selectors/addons'
import BrandDetails from './BrandDetails'
import LoadingBar from '../../../_library/LoadingBar'
import { isEmailValidator } from '../../../../_common/core/validation'
import { getConfig } from '../../../utils/configUtils'

const stepElements = [
  {
    text: 'Event Details',
    iconChildren: <i className="fa fa-check" />,
  },
  {
    text: 'Payment and Brand Support',
    iconChildren: <i className="fa fa-check" />,
  },
]

const EventPublishModal = ({
  isOpen,
  onClose,
  onSubmit,
  eventId,
  FETCH_EVENT,
  UNSELECT_EVENT,
  FETCH_EVENT_TICKETS,
  FETCH_EVENT_ADDONS,
  RESET_INITIAL_ADD_ON,
  FETCH_EVENT_TABLES,
  RESET_INITIAL_TICKETS,
  FETCH_BRAND,
  UNSELECT_BRAND,
  event,
  brand,
  ticketTypes,
  ticketsInitial,
  addOns,
  addOnsInitial,
  tableTypes,
  tablesInitial,
  resetSelectedEventData = false,
}) => {
  const configs = getConfig()
  const isSupportEmailFieldsVisible = _get(
    configs,
    'global.children.EventPublish.appearance.isSupportEmailFieldsVisible',
  )

  const [currentStep, setCurrentStep] = useState(0)
  const [isLoadingEvent, setLoadingEvent] = useState(true)
  const [flagSendPromoterLinks, setFlagSendPromoterLinks] = useState(false)
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)
  const [values, setValues] = useState({})

  const isLastStep = currentStep === stepElements.length - 1
  const modalActions = [
    { value: 'editEvent', label: 'Edit Event', className: 'btn btn-transparent' },
    currentStep && { value: 'back', label: 'Back', className: 'btn btn-transparent' },
    !isLastStep && { value: 'next', label: 'Next', className: 'btn btn-success' },
    isLastStep && {
      value: 'publish',
      label: 'Publish',
      className: 'btn btn-success',
      disabled: isSupportEmailFieldsVisible
        ? !values.externalSupportEmail ||
          (values.externalSupportEmail && Boolean(isEmailValidator()(values.externalSupportEmail))) ||
          !values.internalSupportEmail ||
          (values.internalSupportEmail && Boolean(isEmailValidator()(values.internalSupportEmail)))
        : false,
    },
    { value: 'cancel', label: 'Cancel', className: 'btn btn-cancel' },
  ].filter(Boolean)

  const updateDimensions = () => {
    setIsMobile(window.innerWidth < 768)
  }

  useEffect(() => {
    window.addEventListener('resize', updateDimensions)

    return () => {
      window.removeEventListener('resize', updateDimensions)
    }
  }, [])

  useEffect(() => {
    setValues({
      externalSupportEmail: _get(event, 'externalSupportEmail') || _get(brand, 'externalSupportEmail') || '',
      internalSupportEmail: _get(event, 'internalSupportEmail') || _get(brand, 'internalSupportEmail') || '',
    })
  }, [event, brand])

  useEffect(() => {
    if (!event) {
      setLoadingEvent(true)
      FETCH_EVENT(eventId)
    } else {
      setLoadingEvent(false)
    }
  }, [eventId, event, FETCH_EVENT])

  useEffect(() => {
    if (!brand && event) {
      FETCH_BRAND(event.owner.id)
    }
  }, [event, brand, FETCH_BRAND])

  useEffect(() => {
    if (!ticketTypes || ticketsInitial) {
      FETCH_EVENT_TICKETS(eventId)
    }
  }, [eventId, ticketTypes, ticketsInitial, FETCH_EVENT_TICKETS])

  useEffect(() => {
    if (!tableTypes || tablesInitial) {
      FETCH_EVENT_TABLES(eventId)
    }
  }, [eventId, tableTypes, tablesInitial, FETCH_EVENT_TABLES])

  useEffect(() => {
    if (!addOns || addOnsInitial) {
      FETCH_EVENT_ADDONS(eventId)
    }
  }, [eventId, addOns, addOnsInitial, FETCH_EVENT_ADDONS])

  const handleNextStep = () => {
    setCurrentStep(prevStep => prevStep + 1)
  }

  const onModalAction = actionValue => {
    switch (actionValue) {
      case 'editEvent': {
        window.location.href = `/event/${eventId}/details`
        break
      }
      case 'back': {
        setCurrentStep(currentValue => currentValue - 1)
        break
      }
      case 'next': {
        setCurrentStep(currentValue => currentValue + 1)
        break
      }
      case 'cancel': {
        onClose()
        if (resetSelectedEventData) {
          RESET_INITIAL_TICKETS()
          UNSELECT_EVENT()
          RESET_INITIAL_ADD_ON()
        }
        break
      }
      default: {
        onSubmit({ flagSendPromoterLinks, ...values })
      }
    }
  }

  const handleInputChange = (key, value) => {
    setValues(currValues => ({
      ...currValues,
      [key]: value,
    }))
  }

  return (
    <ConfirmModal
      isOpen={isOpen}
      header="Do you want to publish this event?"
      classNames={{
        modal: 'modal-dialog modal-trans ' + (isMobile ? '' : 'modal-lg'),
        container: 'modal-dialog ' + (isMobile ? '' : 'modal-lg'),
        modal_footer: 'modal-footer publish-modal-footer',
      }}
      content={
        isLoadingEvent ? (
          <LoadingBar />
        ) : (
          <>
            <Steps
              classes={{ container: 'event-publish-steps' }}
              activeStep={currentStep}
              elements={stepElements}
            />
            {currentStep === 0 && (
              <EventDetails
                event={event}
                ticketTypes={ticketTypes}
                addOns={addOns}
                tableTypes={tableTypes}
                onNext={handleNextStep}
              />
            )}
            {currentStep === 1 && (
              <BrandDetails
                event={event}
                brand={brand}
                flagSendPromoterLinks={flagSendPromoterLinks}
                setFlagSendPromoterLinks={setFlagSendPromoterLinks}
                onInputChange={handleInputChange}
                values={values}
              />
            )}
          </>
        )
      }
      actions={modalActions}
      onAction={onModalAction}
      onClose={() => {
        onClose()
        if (resetSelectedEventData) {
          RESET_INITIAL_TICKETS()
          UNSELECT_EVENT()
          RESET_INITIAL_ADD_ON()
          UNSELECT_BRAND()
        }
      }}
    />
  )
}

const mapStateToProps = state => ({
  event: get_event(state),
  brand: get_brand(state),
  ticketTypes: get_event_tickets(state),
  ticketsInitial: get_tickets_initial(state),
  tableTypes: get_event_tables(state),
  tablesInitial: get_tables_initial(state),
  addOns: get_event_addons(state),
  addOnsInitial: get_addons_initial(state),
})

const mapDispatchToProps = {
  FETCH_EVENT,
  FETCH_EVENT_TICKETS,
  FETCH_EVENT_ADDONS,
  FETCH_EVENT_TABLES,
  UNSELECT_EVENT,
  RESET_INITIAL_TICKETS,
  RESET_INITIAL_ADD_ON,
  FETCH_BRAND,
  UNSELECT_BRAND,
}

export default connect(mapStateToProps, mapDispatchToProps)(EventPublishModal)
